import axios from 'axios';

const url = process.env.NODE_ENV === "production" ? "https://teamup-api.jobjournal.io/api/" : "http://192.168.178.24:3001/api/";

export default {
  getUser() {
    return axios.get(url + "return-user/").then((response) => response.data);
  },
  login(credentials) {
    return axios
      .post(url + "login/", credentials)
      .then((response) => response.data);
  },
  signUp(credentials) {
    return axios
      .post(url + "sign-up/", credentials)
      .then((response) => response.data);
  },
  forgotPassword(data) {
    return axios
      .post(url + "forgot-password/", data)
      .then((response) => response.data);
  },
  resetPassword(data) {
    return axios
      .post(url + "reset-password/", data)
      .then((response) => response.data);
  },
  validateToken(data) {
    return axios
      .get(url + "validate-token/", { params: data })
      .then((response) => response.data);
  },
  createPool(data) {
    return axios
      .post(url + "create-pool/", data)
      .then((response) => response.data);
  },
  joinPool(data) {
    return axios
      .post(url + "join-pool/", data)
      .then((response) => response.data);
  },
  leavePool(data) {
    return axios
      .post(url + "leave-pool/", data)
      .then((response) => response.data);
  },
  getPool(data) {
    return axios
      .post(url + "get-pool/", data)
      .then((response) => response.data);
  },
  getUserAdministratedPools() {
    return axios
      .get(url + "get-user-administrated-pools/")
      .then((response) => response.data);
  },
  getUserJoinedPools() {
    return axios
      .get(url + "get-user-joined-pools/")
      .then((response) => response.data);
  },
  getAvailablePools() {
    return axios
      .get(url + "get-available-pools/")
      .then((response) => response.data);
  },
  getUserProfileFromPool(data) {
    return axios
      .post(url + "get-user-profile-from-pool/", data)
      .then((response) => response.data);
  },
  getSingleProfile(data) {
    return axios
      .get(url + "get-single-profile/", {params: data})
      .then((response) => response.data)
  },
  submitUserProfile(data) {
    return axios
      .post(url + "submit-user-profile", data)
      .then((response) => response.data);
  },
  matchGetNextProfiles(data) {
    return axios
      .post(url + "match-get-next-profiles", data)
      .then((response) => response.data);
  },
  matchCastVote(data) {
    return axios
      .post(url + "match-cast-vote", data)
      .then((response) => response.data);
  },
  getUserVotes(data) {
    return axios
      .post(url + "user-votes", data)
      .then((response) => response.data);
  },
  getUserMatches(data) {
    return axios
      .post(url + "user-matches", data)
      .then((response) => response.data);
  },
  getUnvotedProfilesCount(params) {
    return axios
      .get(url + "get-unvoted-profiles-count/", { params })
      .then((response) => response.data);
  },
  getChat(data) {
    return axios.post(url + "get-chat", data).then((response) => response.data);
  },
  sendChat(data) {
    return axios
      .post(url + "send-chat", data)
      .then((response) => response.data);
  },
  uploadImage(data, headers) {
    return axios
      .post(url + "upload", data, headers)
      .then((response) => response.data);
  },
  getProfileImages(data) {
    return axios
      .get(url + "profile-images", { params: data })
      .then((response) => response.data);
  },
  getPoolImage(data) {
    return axios
      .get(url + "pool-image", { params: data })
      .then((response) => response.data);
  },
  getImage(data) {
    return axios
      .get(url + "get-image", { responseType: "blob", params: data })
      .then((response) => response.data);
  },
  removeImage(data) {
    return axios
      .delete(url + "remove-image", { params: data })
      .then((response) => response.data);
  },
  getPushActivationStatus() {
    return axios
      .get(url + "check-push-activation/")
      .then((response) => response.data);
  },
  updateSelectedPool(data) {
    return axios
      .post(url + "/update-selected-pool", data)
      .then((response) => response.data);
  },
  getProfilePrefill(){
    return axios
      .get(url + "/prefill-profile")
      .then((response) => response.data);
  },
  updateSettings(data){
    return axios
      .post(url + "/update-user-settings", data)
      .then((response) => response.data);
  },
  reportUser(data){
    return axios
      .post(url + "report-user", data)
      .then((response) => response.data);
  },
  submitFeedback(data) {
    return axios
      .post(url + "submit-feedback", data)
      .then((response) => response.data);
  },
  getAdminLatestUsers() {
    return axios
      .get(url + "admin/latest-users")
      .then((response) => response.data);
  },
  getAdminPools() {
    return axios
      .get(url + "admin/pools")
      .then((response) => response.data);
  },
  getAdminPoolMembers(pool_id) {
    return axios
      .get(url + "admin/pool-members/" + pool_id)
      .then((response) => response.data);
  },
  getAdminFeedback() {
    return axios
      .get(url + "admin/feedback")
      .then((response) => response.data);
  },
  getAdminHomepageHitsCount() {
    return axios
      .get(url + "admin/homepage-hits-count")
      .then((response) => response.data);
  },
};

